/**
 * AppShell — header + nav + main content area.
 */

import { Link, NavLink, Outlet } from 'react-router-dom';
import { useGallery } from '../state/gallery-store';
import { useEffect } from 'react';
import './AppShell.css';

export function AppShell() {
  const { registry, source, error, load, stats } = useGallery();

  useEffect(() => {
    if (source === 'pending') {
      void load();
    }
  }, [source, load]);

  return (
    <div className="app-shell">
      <header className="app-shell__header">
        <Link to="/" className="app-shell__brand">
          <span className="app-shell__brand-name">FV</span>
          <span className="app-shell__brand-full">Module Gallery</span>
        </Link>

        <nav className="app-shell__nav">
          <NavLink to="/" end className="app-shell__navlink">
            Overview
          </NavLink>
          <NavLink to="/modules" className="app-shell__navlink">
            Modules
            {stats && <span className="app-shell__badge">{stats.total_modules}</span>}
          </NavLink>
          <NavLink to="/bundles" className="app-shell__navlink">
            Bundles
            {stats && <span className="app-shell__badge">{stats.total_bundles}</span>}
          </NavLink>
          <NavLink to="/variants" className="app-shell__navlink">
            Variants
            {stats && stats.total_variants > 0 && (
              <span className="app-shell__badge">{stats.total_variants}</span>
            )}
          </NavLink>
          <NavLink to="/docs" className="app-shell__navlink">
            Docs
          </NavLink>
        </nav>

        <div className="app-shell__status">
          {source === 'pending' && <span className="app-shell__pill">loading…</span>}
          {source === 'live' && <span className="app-shell__pill app-shell__pill--live">live</span>}
          {source === 'bundled' && (
            <span className="app-shell__pill app-shell__pill--bundled">bundled</span>
          )}
          {source === 'error' && <span className="app-shell__pill app-shell__pill--error">error</span>}
        </div>
      </header>

      <main className="app-shell__main">
        {error && (
          <div className="app-shell__error">
            <strong>Failed to load registry:</strong> {error}
            <button
              type="button"
              className="app-shell__retry"
              onClick={() => void load()}
            >
              Retry
            </button>
          </div>
        )}
        <Outlet />
      </main>

      <footer className="app-shell__footer">
        <div>
          FVW v{registry?.fvw_version ?? '?'} · registry v{registry?.version ?? '?'} ·
          generated {registry?.generated_at ?? '?'}
        </div>
        <div>
          <a
            href="https://github.com/avidtech6/fv-module-gallery"
            target="_blank"
            rel="noopener noreferrer"
          >
            fv-module-gallery ↗
          </a>
          {' · '}
          <a
            href="https://github.com/avidtech6/fv-gallery-ui"
            target="_blank"
            rel="noopener noreferrer"
          >
            fv-gallery-ui ↗
          </a>
        </div>
      </footer>
    </div>
  );
}
